// extracted by mini-css-extract-plugin
module.exports = {"students-filter-body":"PrivateEventFilterBody_students-filter-body__irXC2","students-filter-body__link":"PrivateEventFilterBody_students-filter-body__link__hoGgu"};